// extracted by mini-css-extract-plugin
export default {"subjects__body_cards":"subjectcards_subjects__body_cards__MIE5S"};